<div class="main-container"
     [style.height]="height"
     [style.width]="width"
     data-cy="note-compact-v2-main-container">
  <div class="top-bar" data-cy="note-compact-v2-top-bar">
    <div class="patient-name"
         *ngIf="PatientName"
         data-cy="note-compact-v2-patient-name">
      {{ PatientName }}
    </div>
    <button mat-icon-button
            color="primary"
            class="add-button"
            data-cy="note-compact-v2-add-button">
      <i class="material-icons small-icon">add</i>
    </button>
    <button mat-icon-button
            (click)="chooseMode = !chooseMode"
            color="primary"
            class="builder-button"
            matTooltip="Note Builder"
            data-cy="note-compact-v2-builder-button">
      <i class="material-icons small-icon">notes</i>
    </button>
    <button mat-icon-button
            (click)="chooseMode = !chooseMode"
            color="primary"
            class="builder-button"
            matTooltip="Macro Notes"
            data-cy="note-compact-v2-macro-button">
      <i class="material-icons small-icon">account_tree</i>
    </button>
    <button mat-icon-button
            (click)="chooseMode = !chooseMode"
            color="primary"
            class="builder-button"
            matTooltip="Macro Notes"
            data-cy="note-compact-v2-delete-button">
      <i class="material-icons small-icon">delete</i>
    </button>
  </div>
  <div class="notes-container" data-cy="note-compact-v2-notes-container">
    <div class="note-container"
         *ngFor="let dataNoteGroup of dataNoteGroups;let i = index"
         data-cy="note-compact-v2-note-container">
      <div class="relative-container" data-cy="note-compact-v2-relative-container">
        <div *ngIf="chooseMode"
             class="note-container-select"
             data-cy="note-compact-v2-note-select">
          <button mat-icon-button
                  color="primary"
                  class=""
                  data-cy="note-compact-v2-select-button">
            <i class="material-icons small-icon">check</i>
          </button>
        </div>
        <mat-form-field class="textarea-form"
                        [class.textarea-compact]="chooseMode"
                        data-cy="note-compact-v2-textarea-field">
          <textarea matInput
                    cdkTextareaAutosize="true"
                    cdkAutosizeMaxRows="3"
                    cdkAutosizeMinRows="3"
                    [(ngModel)]="dataNoteGroup.dataNote.Note"
                    data-cy="note-compact-v2-textarea"></textarea>
        </mat-form-field>
      </div>      
    </div>    
  </div>
</div>
